import { render } from "./app-loader.vue?vue&type=template&id=f80cbe42&scoped=true&ts=true"
import script from "./app-loader.vue?vue&type=script&lang=ts"
export * from "./app-loader.vue?vue&type=script&lang=ts"

import "./app-loader.vue?vue&type=style&index=0&id=f80cbe42&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80cbe42"]])

export default __exports__